import MainPage from '../pages/main';
import { RouteType } from '../types/route-types';

export const routes: RouteType[] = [
  {
    path: '/',
    Element: MainPage
  }
];
